import { NavLink } from 'react-router-dom';

import { useConfig } from 'shared/featureFlagConfig/useConfig';

import { FeatureFlags } from '../../../../shared/featureFlagConfig/configFromAdmin';

type Props = {
  featureFlag: FeatureFlags;
  to: string;
  children: React.ReactNode;
  testId?: string;
};

export const FeatureFlagNavLink = ({ featureFlag, to, children, testId }: Props) => {
  const showLink = useConfig(featureFlag);

  if (showLink) {
    return (
      <li>
        <NavLink data-testid={testId} activeClassName="active" to={to}>
          {children}
        </NavLink>
      </li>
    );
  }

  return null;
};
